import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';

import {gqlGroupMember} from '../../Groups/getGroupMember.api';
import {OverdueWcvDocument} from '../../../graphql/documents.datatypes';

import {gqlDocument} from '../getDocument.api';

interface DocumentsData {
    myDocumentsFull: OverdueWcvDocument[]
}

export const GET_DOCUMENTS_QUERY = gql`
    query getMyDocumentsFull{
        myDocumentsFull{
            document {
                ${gqlDocument}
            }
            
            groupMember {
                ${gqlGroupMember}
            }
        }
    }
`;

export const getMyDocumentsFull = () => useQuery<DocumentsData>(
    GET_DOCUMENTS_QUERY,
    {
        variables: {
        },
        
    }
);

export default getMyDocumentsFull;